/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ReactComponent as EditIcon } from 'Images/icon_edit.svg';
// import { ReactComponent as DeleteIcon } from 'Images/icon-toolbar-delete.svg';
import { ReactComponent as TrashIcon } from 'Images/icon-action-bar-trash.svg';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2px 0px;
  text-align: right;
  margin: 0px;
  box-sizing: border-box;
  height: 37px;
  margin-bottom: 9px;
`;
Wrapper.displayName = 'Wrapper';

export const Edit = styled(EditIcon)`
    width: 18px;
    height: 17px;
    display: block;
    overflow: visible;

    & path {
        fill: ${({ theme }) => theme.icons.actionBar.color} !important;
    }

`;

export const Delete = styled(TrashIcon)`
    width: 19px;
    height: 18px;
    display: block;
    overflow: visible;

    g > path { 
        fill: ${colors.red1} !important;
    }
  

`;
